import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEditService } from './base-edit.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseEditCopyService<T, TEdit> extends BaseEditService<T, TEdit> {
  protected constructor(baseRoute: string, name: string) {
    super(baseRoute, name);
  }

  copy(id: string, key?: string): Observable<string> {
    // Encoded: a key can hold characters a query string reads differently - "CC&B01" arrived as
    // "CC", and a space or '+' was mangled too. Left as it was when no key is passed (the order
    // and contract copies), so those calls send exactly what they always have.
    const keyParam = key === undefined ? key : encodeURIComponent(key);
    return this.httpService.get<string>(`${this.apiUrl}/Copy?id=${id}&key=${keyParam}`);
  }
}
